import React from 'react';
import { QrReader } from '@blackbox-vision/react-qr-reader';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { camera, closeCircle } from 'ionicons/icons';

interface IPart {
  scannerResult: (data: string) => void;
}

interface IState {
  QRScannerVisible: boolean;
}

interface ScannerProps {
  items: IPart;
  present: (message: string, duration: number) => void;
}

class Scanner extends React.Component<ScannerProps, IState> {
  lastResult: string = '';

  constructor(props: ScannerProps) {
    super(props);
    this.state = { QRScannerVisible: false };
  }

  handleScan = (result: any, error: any) => {
    if (!!result) {
      const text = result.getText();

      if (!text.startsWith("https://parcours.valais.cloud")) {
        this.props.present("QR code non valide", 2000);
      } else {
        this.props.items.scannerResult(text);
        this.lastResult = text;
        this.setState({ QRScannerVisible: false });
      }
    }

    if (error) {
      console.error("QR scan error:", error);
    }
  };

  toggleScanner = () => {
    this.setState((prev) => ({ QRScannerVisible: !prev.QRScannerVisible }));
  };

  render() {
    const { QRScannerVisible } = this.state;

    return (
      <IonGrid>
        <IonRow>
          <IonCol>
            {QRScannerVisible && (
              <IonButton color="danger" onClick={this.toggleScanner}>
                <IonIcon slot="icon-only" icon={closeCircle} />
              </IonButton>
            )}
          </IonCol>
        </IonRow>

        <IonRow>
          <IonCol>
            {QRScannerVisible ? (
              <div style={{ width: '100%' }}>
                <QrReader
                    constraints={{ facingMode: 'environment' }}
                    onResult={this.handleScan}
                />
                </div>
            ) : (
              <IonButton expand="full" onClick={this.toggleScanner}>
                <IonIcon slot="icon-only" icon={camera} />
              </IonButton>
            )}
          </IonCol>
        </IonRow>
      </IonGrid>
    );
  }
}

export default Scanner;
